import { XCircle, CheckCircle, Bell } from "lucide-react";

const taskTabs = ["unassigned", "assigned", "successful"];

export default function TaskPanel({
  tasks,
  filteredTasks,
  isLoading,
  selectedTaskTab,
  setSelectedTaskTab,
  setTaskToAssign,
  setShowAssignModal,
  onAssignClick,
  setSelectedTask,
  setShowDetailsModal,
  SyncWithAnlook,
  FetchTaskCall,
  loading,
  isChecked,
  handleToggle,
  onInstructionClick = () => {},
  instructionTaskIds = new Set(),
  tempFromDate,
  tempToDate,
  setTempFromDate,
  setTempToDate
}) {

  return (
    <div className="w-[400px] min-w-[400px] bg-gray-50 border-r border-gray-200 rounded-lg shadow-sm h-full flex flex-col">
      {/* HEADER  */}
      <div className="text-black p-3 flex justify-between font-semibold text-2xl border-b bg-white z-10">
        Tasks
        <div
          role="tablist"
          aria-label="Switch Auto/Manual"
          className={`relative inline-grid grid-cols-2 w-[88px] rounded-full bg-gray-100 border border-gray-200 p-1 ${
            loading ? "opacity-60 pointer-events-none" : ""
          }`}
        >
          <span
            aria-hidden="true"
            className="absolute top-1 bottom-1 left-1 rounded-full bg-white shadow transition-transform duration-300 ease-in-out pointer-events-none"
            style={{
              width: "calc(50% - 0.25rem)",
              transform: isChecked ? "translateX(100%)" : "translateX(0%)",
            }}
          />

          <button
            type="button"
            className="relative z-10 flex items-center justify-center px-1 py-1 rounded-full"
            onClick={() => handleToggle(false)}
          >
            <XCircle
              className={`h-4 w-4 ${
                !isChecked ? "text-red-500" : "text-gray-500"
              }`}
            />
          </button>

          <button
            type="button"
            className="relative z-10 flex items-center justify-center px-1 py-1 rounded-full"
            onClick={() => handleToggle(true)}
          >
            <CheckCircle
              className={`h-4 w-4 ${
                isChecked ? "text-green-600" : "text-gray-500"
              }`}
            />
          </button>
        </div>
      </div>

      {/* DATE FILTERS  */}
      <div className="px-2 py-2 border-b flex gap-2 items-end bg-white sticky top-0 z-10">
        <input
          type="date"
          value={tempFromDate}
          onChange={(e) => setTempFromDate(e.target.value)}
          className="bg-white border px-2 py-1 rounded text-sm shadow-sm flex-1"
        />

        <input
          type="date"
          value={tempToDate}
          onChange={(e) => setTempToDate(e.target.value)}
          className="bg-white border px-2 py-1 rounded text-sm shadow-sm flex-1"
        />

        <button
          onClick={() => FetchTaskCall?.()}
          className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 rounded text-sm shadow w-[75px]"
        >
          Apply
        </button>
      </div>

      {/*  TASK TABS  */}
      <div className="flex justify-around border-b bg-white px-3 py-1 shadow-sm">
        {taskTabs.map((tab) => (
          <div
            key={tab}
            className={`cursor-pointer px-2 py-1 text-center text-xs font-medium rounded-t-md transition-all ${
              selectedTaskTab === tab
                ? "text-orange-600 border-b-2 border-orange-600"
                : "text-gray-600"
            }`}
            onClick={() => setSelectedTaskTab(tab)}
          >
            <div className="text-lg font-bold">
              {
                tasks.filter((t) => {
                  if (tab === "assigned") {
                    return !["unassigned", "successful"].includes(t.status);
                  }
                  return t.status === tab;
                }).length
              }
            </div>
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </div>
        ))}
      </div>

      {/* ========== TASK LIST ========== */}
      <div className="overflow-y-auto p-3 space-y-3 flex-1">
        {isLoading && (
          <p className="text-gray-400 text-sm text-center">Loading tasks...</p>
        )}

        {filteredTasks.map((task) => (
          <div
            key={task.id || task.pk_task_id}
            className="relative bg-white rounded-lg shadow border-l-4 p-3"
            style={{ borderColor: "#FC981B" }}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-semibold">
                Order : {task.order_id}
              </span>

              {(instructionTaskIds?.has(String(task.pk_task_id)) ||
                instructionTaskIds?.has(task.pk_task_id)) && (
                <button
                  onClick={() => onInstructionClick(task.pk_task_id)}
                  className="text-orange-600 text-sm mx-4"
                >
                  <Bell size={18} />
                </button>
              )}

                {task.status === "unassigned" && (
  <button
    className="text-xs bg-green-500 text-white px-3 py-1 rounded"
    onClick={() => {
      if (typeof onAssignClick === "function") {
        onAssignClick(task);
        return;
      }

      setTaskToAssign(task);
      setShowAssignModal(true);
    }}
  >
    Assign Driver
  </button>
)}
          
            </div>

            <hr className="my-2 border-gray-300" />

            <div className="bg-gray-100 rounded-md p-3 space-y-2 text-xs text-gray-700">
              <div>
                <b>Pickup:</b> {task.pickup_address}
              </div>
              <div>
                <b>Drop:</b> {task.delivery_address}
              </div>
              {task.driver_name && (
                <div>
                  <b>Driver:</b> {task.driver_name} / {task.driver_mobile}
                </div>
              )}
            </div>

            <div className="flex items-center mt-2 gap-3">
              <button
                onClick={() => SyncWithAnlook(task.pk_task_id)}
                className="text-orange-500 text-xs"
              >
                ⟳
              </button>

              <button
                onClick={() => {
                  setSelectedTask(task);
                  setShowDetailsModal(true);
                }}
                className="text-blue-600 text-xs underline"
              >
                Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}